import App from 'app/app.js';
import 'app/action/ContentChangeAction.js';
import 'app/action/ActiveJobChangedAction.js';
import 'app/store/ContentStore.js';
import 'app/store/ProductCatalogStore.js';
import 'app/store/UserProfileStore.js';

function LtContentItemDirective(
  ContentStore,
  ContentChangeAction,
  ActiveJobChangedAction,
  ProductCatalogStore,
  UserProfileStore,
  $timeout
) {
  return {
    scope: {
      focus: '@'
    },
    restrict: 'AE',
    link: function (scope, element, attrs) {
      var loadContent = function () {
        if (UserProfileStore.getEmail() === ContentStore.getConfig().mltContentPromozoneAdmin) {
          element.html('<div class="promo-place-holder">' + attrs.zone + '</div>');
          return;
        }

        var contentHtml = '';
        // we will check if the promocode is true, then check for the promotion code present in product catalog and display promo.
        if (attrs.promocode) {
          var promoContent = ContentStore.getZoneDetails(attrs.zone);
          var listOfPromos = [];
          // filtering content resources of promo zone.
          if (promoContent) {
            listOfPromos = promoContent.filter(function (zoneDetail) {
              return R.any(R.propEq('promotionCode', zoneDetail.code))(
                ProductCatalogStore.getProductCatalog().promotions || []
              );
            });
          }
          // build content carousel for promo zone.
          if (listOfPromos.length === 1) {
            contentHtml = listOfPromos[0].contentItem;
          } else if (listOfPromos.length > 1) {
            contentHtml += '<div id="promoCarousel" class="promo-carousel carousel slide">';
            contentHtml += '<div class="carousel-inner" role="listbox">';
            for (var promoIndex = 0; promoIndex < listOfPromos.length; promoIndex++) {
              if (promoIndex === 0) {
                contentHtml += '<div class="item active">';
              } else {
                contentHtml += '<div class="item">';
              }
              contentHtml += listOfPromos[promoIndex].contentItem;
              contentHtml += '</div>';
            }
            contentHtml += '</div></div>';
          }
        } else if (attrs.suggestiveselling) {
          contentHtml = ContentStore.getContent(null, attrs.code);
        } else {
          contentHtml = ContentStore.getContent(attrs.zone);
        }

        element.html(contentHtml);

        $timeout(function () {
          $('#promoCarousel').carousel({ interval: window.promoBannerInterval || 5000 });
        });
      };

      loadContent();

      scope.$onDestroy = function () {
        ContentChangeAction.register(function (event) {
          loadContent();
        });
        ActiveJobChangedAction.register(function (event) {
          loadContent();
        });
      };
    }
  };
}

App.directive('ltContentItem', [
  'ContentStore',
  'ContentChangeAction',
  'ActiveJobChangedAction',
  'ProductCatalogStore',
  'UserProfileStore',
  '$timeout',
  LtContentItemDirective
]);
